var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "block_inp p-3" }, [
    _c("div", { staticClass: "form-group mt-2" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "advanced_name" } },
        [_vm._v("\n\t\t\tНазва питання\n\t\t")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "input-group flex-nowrap" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.question.title,
              expression: "question.title",
            },
          ],
          staticClass: "form-control",
          attrs: { id: "advanced_name", type: "text" },
          domProps: { value: _vm.question.title },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.question, "title", $event.target.value)
            },
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-4 col-lg-4 col-sm-4 col-md-4" }, [
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "advanced_name" } },
            [_vm._v("\n\t\t\t\t\tТип питання\n\t\t\t\t")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group flex-nowrap" },
            [
              _c("b-form-radio-group", {
                attrs: {
                  id: "btn-radios-1",
                  "button-variant": "outline-primary",
                  options: [
                    { text: "При вїзді", value: "in" },
                    { text: "При виїзді", value: "out" },
                  ],
                  name: "radios-btn-default",
                  buttons: "",
                },
                model: {
                  value: _vm.question.type,
                  callback: function ($$v) {
                    _vm.$set(_vm.question, "type", $$v)
                  },
                  expression: "question.type",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4 col-lg-4 col-sm-4 col-md-4" }, [
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "advanced_name" } },
            [_vm._v("\n\t\t\t\t\tТМЦ тип\n\t\t\t\t")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group flex-nowrap" },
            [
              _c("b-form-radio-group", {
                attrs: {
                  id: "btn-radios-1",
                  "button-variant": "outline-primary",
                  options: [
                    { text: "Завоз ТМЦ", value: "in_tmz" },
                    { text: "Вивоз  ТМЦ", value: "out_tmz" },
                  ],
                  name: "radios-btn-default",
                  buttons: "",
                },
                model: {
                  value: _vm.question.tmz_type,
                  callback: function ($$v) {
                    _vm.$set(_vm.question, "tmz_type", $$v)
                  },
                  expression: "question.tmz_type",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4 col-lg-4 col-sm-4 col-md-4" }, [
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "advanced_name" } },
            [_vm._v("\n\t\t\t\t\tUPROX validate\n\t\t\t\t")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group flex-nowrap" },
            [
              _c("b-form-radio-group", {
                attrs: {
                  id: "btn-radios-1",
                  "button-variant": "outline-primary",
                  options: [
                    { text: "Так", value: "1" },
                    { text: "Ні", value: "0" },
                  ],
                  name: "radios-btn-default",
                  buttons: "",
                },
                model: {
                  value: _vm.question.uprox_check,
                  callback: function ($$v) {
                    _vm.$set(_vm.question, "uprox_check", $$v)
                  },
                  expression: "question.uprox_check",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mt-4" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v("\n\t\t\tПривязка до типу ОС\n\t\t"),
      ]),
      _vm._v(" "),
      _vm.types.length > 0
        ? _c(
            "div",
            {},
            [
              _c(
                "v-select",
                {
                  staticClass: "imc_reasons",
                  attrs: {
                    multiple: "",
                    label: "name",
                    options: this.types,
                    filterable: false,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "option",
                        fn: function (option) {
                          return [
                            _c("div", { staticClass: "d-center" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(option.name) +
                                  "\n\t\t\t\t\t"
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1465996790
                  ),
                  model: {
                    value: _vm.active_type,
                    callback: function ($$v) {
                      _vm.active_type = $$v
                    },
                    expression: "active_type",
                  },
                },
                [
                  _c("template", { slot: "no-options" }, [
                    _vm._v("\n\t\t\t\t\tОберіть Тип(и)\n\t\t\t\t"),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }